module.exports = __webpack_public_path__ + "static/media/IMG-20191219-WA0000.b052a03d.jpg";